import { useCallback } from "react";
function useCombinedRefs(...refs) {
    return useCallback((value)=>setRefs(value, refs), refs);
}
function setRefs(value, refs) {
    for (const ref of refs)if ('function' == typeof ref) ref(value);
    else if (ref) ref.current = value;
}
export { setRefs, useCombinedRefs };
